import { render, staticRenderFns } from "./ListPlegableLegend.vue?vue&type=template&id=64182512&scoped=true"
import script from "./ListPlegableLegend.vue?vue&type=script&lang=js"
export * from "./ListPlegableLegend.vue?vue&type=script&lang=js"
import style0 from "./ListPlegableLegend.vue?vue&type=style&index=0&id=64182512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64182512",
  null
  
)

export default component.exports